import { Box, Stack, TextField, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useFormikContext } from 'formik';
import { get } from 'lodash';
import dayjs, { Dayjs } from 'dayjs';
import { DateRange, DateRangePicker } from '@adamftd/x-date-pickers-pro';
import { PickerChangeHandlerContext } from '@mui/x-date-pickers';

// Components
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import ModalComponent from 'src/components/Modal/ModalComponent';
import FormikForm from 'src/components/common/FormikForm';
import { FORMAT_DATE_TIME } from 'src/utils/constants/config';

interface IProps {
  open: boolean;
  handleClose: () => void;
}

const FormFilterBookmarks: React.FC<IProps> = ({ open, handleClose }) => {
  const formik = useFormikContext<ExpectedAny>();
  const theme = useTheme();

  const getDefaultValueRangeTime: () => [Dayjs | null, Dayjs | null] = () => {
    if (!formik.values.date_to || !formik.values.date_from) return [null, null];

    const fromTime = dayjs(formik.values.date_from, FORMAT_DATE_TIME.DD_MM_YYYY);
    const toTime = dayjs(formik.values.date_to, FORMAT_DATE_TIME.DD_MM_YYYY);
    return [fromTime, toTime];
  };

  return (
    <ModalComponent padding={4} handleClose={handleClose} open={open}>
      <FormikForm formik={formik}>
        <Box width={540}>
          <Typography textAlign={'center'} variant="h5">
            Filter Bookmark
          </Typography>
          <Box sx={{ mt: 1 }} />
          <Typography textAlign={'center'} color={theme.palette.text.secondary} variant="body2">
            Please select the filter conditions below.
          </Typography>
          <Box sx={{ mt: 4 }} />

          <Stack direction={'column'} spacing={2}>
            <DateRangePicker
              defaultValue={getDefaultValueRangeTime()}
              format={FORMAT_DATE_TIME.FULL_ONLY_DATE}
              onChange={(value: DateRange<Dayjs>, context: PickerChangeHandlerContext<ExpectedAny>) => {
                let fromTime,
                  toTime = '';
                if (value[0]) {
                  fromTime = dayjs(value[0]).format(FORMAT_DATE_TIME.DD_MM_YYYY);
                }
                if (value[1]) {
                  toTime = dayjs(value[1]).format(FORMAT_DATE_TIME.DD_MM_YYYY);
                }
                formik.setFieldValue('date_from', fromTime);
                formik.setFieldValue('date_to', toTime);
              }}
              slotProps={{
                textField: { size: 'small' },
                actionBar: {
                  actions: ['clear'],
                },
              }}
              localeText={{ start: 'Incorporation Date From', end: 'To' }}
            />
            <TextField
              id="keyword"
              name="keyword"
              value={get(formik.values, 'keyword', '')}
              size="small"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
              error={Boolean(formik.touched.keyword && formik.errors.keyword)}
              label="Search"
            />
            <ButtonWithLoading sx={{ height: 53 }} size="large" variant="contained" isRounded type="submit">
              Show Result
            </ButtonWithLoading>
          </Stack>
        </Box>
      </FormikForm>
    </ModalComponent>
  );
};

export default FormFilterBookmarks;
